module.exports = __webpack_public_path__ + "static/media/star-shooting.8221e485.svg";